<template lang="pug">
  vue-circle.progress(
    :id='id'
    :start-angle='-Math.PI / 2'
    :progress='progress'
    :size='size'
    :reverse="false"
    line-cap="round"
    :fill="{ color: color }"
    empty-fill="rgba(0, 0, 0, .1)"
    insert-mode="append"
    :thickness="thickness"
    :inner-text='formattedLabel')

</template>

<script>
import VueCircle from "vue2-circle-progress";
import numeral from "numeral";

export default {
  components: { VueCircle },
  props: {
    id: {
      required: true
    },
    label: {
      required: false
    },
    total: {
      required: true,
      type: Number
    },
    count: {
      required: true,
      type: Number
    },
    size: {
      type: Number,
      default: 140
    },
    countLabel: {
      type: [String, Number]
    },
    color: {
      type: String,
      default: "red"
    },
    thickness: {
      type: Number,
      default: 4
    }
  },
  computed: {
    progress() {
      // eslint-disable-next-line
      return this.count / (this.total || 1) * 100;
    },
    formattedCount() {
      return numeral(this.count).format("0.a");
    },
    countDisplay() {
      return this.countLabel || this.formattedCount;
    },
    formattedLabel() {
      return `<div class="progress-label">${this.countDisplay}</div> ${
        this.label
      }`; // Bit hacky, but works for now...
    }
  }
};
</script>

<style lang="scss">
.progress {
  .progress-label {
    font-size: 28px;
  }
  span {
    top: 30% !important;
    font-size: 13px;
    color: black;
  }
}
</style>

<style scoped lang="scss"></style>
